import React, { FC } from "react";
import clsx from "clsx";
import { Button } from "../Button";
import type { ButtonPropsType } from "../Button";
import styles from "./icon-button.module.scss";

export interface IconButtonPropsType
  extends Omit<ButtonPropsType, "children" | "icon" | "iconPosition"> {
  icon: React.ReactNode;
  "aria-label": string; // Make required for accessibility (overrides optional from HTMLButtonElement)
  shape?: "circular" | "square";
}

export const IconButton: FC<IconButtonPropsType> = ({
  icon,
  "aria-label": ariaLabel,
  variant = "ghost",
  shape = "circular",
  className,
  ...props
}): JSX.Element => {
  const iconButtonClass =
    shape === "square" ? styles["icon-button-square"] : styles["icon-button"];

  return (
    <Button
      {...props}
      variant={variant}
      className={clsx(iconButtonClass, className)}
      aria-label={ariaLabel}
    >
      {icon}
    </Button>
  );
};
